export default "__VITE_ASSET__BT_DiMQZ__"